// composables/useImageUrl.ts
/*
* eager: true 確保這些文件在編譯時立即被導入。
import: 'default' 確保直接導入文件的默認導出（在這種情況下是文件的 URL）。*/
export const useImageUrl = (path: string, name: string): string => {
    const assets =
        import.meta.glob('~/assets/image/**/*', { eager: true, import: 'default' }) as Record<string, string>;
    return assets[`/assets/image/${path}/${name}`];
};
